import { render, staticRenderFns } from "./TaskCreator.vue?vue&type=template&id=64ca72e2"
import script from "./TaskCreator.vue?vue&type=script&lang=js"
export * from "./TaskCreator.vue?vue&type=script&lang=js"
import style0 from "./TaskCreator.vue?vue&type=style&index=0&id=64ca72e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports